
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import {
  companyPayInfo,
  generateCompanyPay,
  orderDetail,
  submitCompanyPay
} from '@/services/http';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import TransferDialog from '@/components/transfer-dialog/index.vue';
import { readCookie } from '@/tools/tools';

@Component({
  name: 'TransferPayment',
  components: {
    Header,
    Footer,
    TransferDialog
  }
})
export default class extends Vue {
  dialogVisible: boolean = false;

  transferStatus: number = 1;

  orderAmount: string = '';

  accountName: string = '';

  accountNo: string = '';

  bankName: string = '';

  payerName: string = '';

  voucherImage: string = '';

  deadline: string = '';

  surplus: number = 0;

  created() {
    this.getTransferAmount();
    this.getOrderTime();
  }

  // 获取订单剩余支付时间，与支付页右上角倒计时保持一致。
  async getOrderTime() {
    const anchor = readCookie('anchor');
    let src = 4;
    let equip = 4;
    let version = '';
    if (anchor) {
      src = anchor.src ? anchor.src : 2;
      equip = anchor.equip;
      version = anchor.version;
    }
    const res: any = await orderDetail({
      orderNo: this.$route.query.id,
      src,
      equip,
      version
    });
    if (res.data.code === 100) {
      this.surplus = Number(res.data.data.surplus);
      this.deadline = moment().add(this.surplus, 'seconds').format('YYYY年MM月DD日HH:mm:ss');
    }
  }

  // 进入对公打款成功页时生成打款金额。
  async getTransferAmount() {
    const res: any = await generateCompanyPay({ orderNo: this.$route.query.id as string });
    if (res.data.code === 100) {
      this.orderAmount = String(res.data.data.payAmount);
    }
  }

  // 点击去打款时查询并展示对公收款信息。
  async showDialog() {
    const res: any = await companyPayInfo({ orderNo: this.$route.query.id as string });
    if (res.data.code === 100) {
      const [info] = res.data.data;
      this.orderAmount = String(info.payAmount);
      this.accountName = info.payeeAccountName;
      this.accountNo = info.payeeBankNo;
      this.bankName = info.payeeBank;
      this.dialogVisible = true;
    }
  }

  // 提交已上传的凭证地址，成功后进入平台核对状态。
  async handleSubmitVoucher(payload: any) {
    let success = false;
    try {
      const submitRes: any = await submitCompanyPay({
        orderNo: payload.orderNo,
        payerName: payload.voucherName,
        voucherUrl: payload.voucherUrl
      });
      success = submitRes.data.code === 100;
      if (success) {
        this.payerName = payload.voucherName;
        this.voucherImage = payload.voucherUrl;
        this.transferStatus = 2;
        this.$message.success('提交成功');
      } else {
        this.$message.error(submitRes.data.message);
      }
    } finally {
      payload.complete(success);
    }
  }

  // 关闭对公打款弹窗。
  handleCloseDialog() {
    this.dialogVisible = false;
  }
}
